import { createRouter, createWebHistory } from 'vue-router'
// import Cookies from 'js-cookie'

const routes = [
    {
        path: '/formulario',
        component: () => import('@/layouts/SideBar.vue'),
        children: [
            {
                path: '/formulario',
                name: "Formulario",
                component: () => import('@/layouts/FormLayout.vue'),
                meta: {
                    title: 'Abertura de Chamado'
                }
            },
        ],

    },
    {
        path: '/token',
        component: () => import('@/layouts/AuthLayout.vue'),
        props: route => ({auth: route.query.auth})
    },
    {
        path: '/meus-chamados',
        component: () => import('@/layouts/SideBar.vue'),
        children: [
            {
                path: '',
                name: "Home",
                component: () => import('@/layouts/HomeLayout.vue'),
                meta: {
                    title: 'Abertura de Chamado'
                }
            },
        ],
        meta: {
            title: 'Central de Chamados'
        }
    },
    {
        path: '/home',
        component: () => import('@/layouts/SideBar.vue'),
        children: [
            {
                path: '',
                name: "Inicio",
                component: () => import('@/layouts/CardLayout.vue'),
                meta: {
                    title: 'Página Inicial'
                }
            },
        ],
    },


    {
        path: '/spu/token',
        component: () => import('@/layouts/SPU/AutenticacaoSPU.vue'),
        props: route => ({ auth: route.query.auth })
    },

    {
        path: '/spu',
        component: () => import('@/layouts/SPU/SideBarSPU.vue'),
        children: [
            {
                path: '',
                redirect: '/spu/home'
            },
            {
                path: 'home',
                name: "InicioSPU",
                component: () => import('@/layouts/SPU/CardSPU.vue'),
                meta: { title: 'Página Inicial SPU' }
            },
            {
                path: 'formulario',
                name: "FormularioSPU",
                component: () => import('@/layouts/SPU/FormSPU.vue'),
                meta: { title: 'Abertura de Chamado SPU' }
            },
            {
                path: 'meus-chamados',
                name: "MeusChamadosSPU",
                component: () => import('@/layouts/SPU/HomeSPU.vue'),
                meta: { title: 'Central de Chamados SPU' }
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;
    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

// const DEFAULT_TITLE = import.meta.env.VITE_API_TITLE;
router.beforeEach(async (to, from, next) => {
  document.title = 'GLPI - Poder Judiciário do Estado de Alagoas | ' + to.meta.title || 'GLPI - Poder Judiciário do Estado de Alagoas';

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = {
      to,
      from,
      next
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    nextMiddleware({ ...context, next: nextMiddleware });
  }

    // const accessToken = to.query.access_token;
    // const refreshToken = to.query.refresh_token;
    // const expiresIn = to.query.expires_in;
    // // const redirectSSO = `${import.meta.env.VITE_SSO_URL}/login`;
    // if (accessToken && refreshToken && expiresIn) {
    //     const expirationDate = new Date(Date.now() + Number(expiresIn) * 1000);
    //     const isSecure = window.location.protocol === 'https:';
    //
    //     // Cookies.set('access_token', accessToken, { expires: expirationDate, secure: isSecure, sameSite: 'Strict' });
    //     // Cookies.set('refresh_token', refreshToken, { expires: 30, secure: isSecure, sameSite: 'Strict' });
    //     // Cookies.set('expires_in', expiresIn, { expires: expirationDate, secure: isSecure, sameSite: 'Strict' });
    //
    //     next({ path: to.path, query: {} });
    //     return;
    // }


    // try {
    //     const token = Cookies.get('access_token');
    //     if (token) {
    //         next();
    //     } else {
    //         next(redirectSSO + '/login');
    //     }
    // } catch (error) {
    //     next(redirectSSO + '/login');
    // }

  next()
})

export default router